
function $(s){return document.querySelector(s)}
function toggle(sel,cls){var e=$(sel);if(e)e.classList.toggle(cls)}
document.addEventListener('click',function(ev){
  var t=ev.target.closest('[data-act]'); if(!t) return;
  var a=t.getAttribute('data-act');
  if(a==='menu'){toggle('.drawer','open');toggle('.scrim','show')}
  if(a==='cart'){toggle('.cart-drawer','open');toggle('.scrim','show')}
  if(a==='closeAll'){$('.drawer')&&$('.drawer').classList.remove('open');$('.cart-drawer')&&$('.cart-drawer').classList.remove('open');$('.scrim').classList.remove('show')}
  if(a==='acc'){t.closest('.accordion').classList.toggle('open')}
  if(a==='gate'){$('.gate').classList.add('hidden')}
});

/* age gate: remembered for the session */
(function(){
  var g=document.querySelector('.gate'); if(!g) return;
  try{ if(sessionStorage.getItem('auch-age')==='1'){ g.classList.add('hidden'); } }catch(e){}
  g.addEventListener('click',function(ev){
    if(ev.target.closest('[data-act="gate"]')){ try{sessionStorage.setItem('auch-age','1')}catch(e){} }
  });
})();
